export default "__VITE_ASSET__DRCHpZxU__"